import { getRequestHeader, handleErrors } from '../actions/initAction';
import { requesterrorType, requestType, requestStartType } from '../store/requestTypes';

export const actionCreators = {
    request: solarobj => async (dispatch, getState) => {

        let forceRefresh = solarobj.forceRefresh || false;
        let post = solarobj.post || false;

        if (isLoaded(getState, solarobj.receiveType) && !forceRefresh) {
            // Don't issue a duplicate request (we already have or are loading the requested data)
            return;
        }

        if (forceRefresh) {
            dispatch({ type: requestStartType.type });
        }

        dispatch({ type: requestType.type });
        let config = getState().clientConfigurationReducer.clientConfiguration || null;
        let url = (typeof (config.solarapiUrl) !== 'undefined' ? config.solarapiUrl.replace('undefined', '') : 'http://localhost:1832/api/') + solarobj.url;
        await fetch(url, getRequestHeader(post))
            .then(handleErrors)
            .then(res => res.json())
            .then(json => {
                if (typeof (solarobj.forceRefresh) !== 'undefined') solarobj.forceRefresh = false;
                dispatch({ type: solarobj.receiveType, value: json.d });
                console.log("fertig " + solarobj.receiveType);
            })
            .catch(error => dispatch({ type: requesterrorType.type, error: error }))

        console.log("ende " + solarobj.receiveType);
    },
    reset: solarobj => async (dispatch, getState) => {

        dispatch({ type: solarobj.receiveType });

        console.log("ende " + solarobj.receiveType);
    },
    showLoader: val => async (dispatch, getState) => {

        dispatch({ type: "showLoader", value: val });

        console.log("ende showLoader");
    },
    Loaded: val => async (dispatch, getState) => {
        
        dispatch({ type: "isLoaded", value: val });

        console.log("ende isLoaded");
    },
};

function isLoaded(getState, receiveType) {
    let reducer = receiveType.split('_')[2];
    let state = getState();
    return state[reducer] && state[reducer].isLoaded;
}


